const TABS_CONTAINER = 'data-tabs-container';
const TABS_TRIGGER = 'data-tabs-trigger';
const TABS_TAB = 'data-tabs-tab'

function init() {
  const $containers = jQuery(`[${TABS_CONTAINER}]`);

  // no containers cancel loading
  if ( ! $containers.length) {
    return;
  }

  $containers.each((key, container) => {
    const $container = jQuery(container);
    const $triggers = $container.find(`> div > ul > li > a[${TABS_TRIGGER}]`);
    const $tabs = $container.find(`> div > [${TABS_TAB}]`);

    $triggers.on('click', function (event) {
      event.preventDefault();
      const $trigger = jQuery(this);
      const tabId = $trigger.attr(TABS_TRIGGER);
      const $tab = $container.find(`> div > [${TABS_TAB}=${tabId}]`);
      $triggers.removeClass('current');
      $tabs.removeClass('current');
      $trigger.addClass('current');
      $tab.addClass('current');
    });
  });
}

export default { init }









